import React from 'react';
import { useClassnames } from '@wb-tech/ui-react';
import { useTranslation } from 'react-i18next';

import { useGetApiV5BonusPlansQuery } from '#adapter/api/campaigns/v5/bonus/plans';

import { getClosestBonus } from './get-closest-bonuses';

import style from './index.module.pcss';

export const ChineseBonuses = () => {
    const cn = useClassnames(style);
    const { t } = useTranslation();

    const { data } = useGetApiV5BonusPlansQuery({});

    if(!data) {
        return null;
    }
    const closestBonus = getClosestBonus(data?.bonuses);

    if(!closestBonus) {
        return null;
    }

    return (
        <p className={cn('chinese-bonuses')}>
            {t('components.chinese-bonuses.text', closestBonus)}
        </p>
    );
};
